import type { Component } from 'vue'
import PkToolApprovalPreviewMessage from './PkToolApprovalPreviewMessage.vue'
import { CONFIRM_TOOL_NAME } from './utils'

/**
 * Maps a tool name to the component that renders a human-readable preview of
 * its input inside `PkToolApprovalCard`. The preview receives the tool call
 * input as its `input` prop.
 *
 * Registering a preview needs no change to the card: tools with no entry here
 * show only the localized confirmation prompt (no raw echo of the call input).
 * Reuse the component that already renders that kind of payload when there is
 * one (e.g. `sendEmail` will reuse `PkToolShowEmail`).
 */
export const toolApprovalPreviews: Record<string, Component> = {
    // The model already writes the sentence to confirm: show it verbatim.
    [CONFIRM_TOOL_NAME]: PkToolApprovalPreviewMessage,
}
